import { render, staticRenderFns } from "./SpecialityTab.vue?vue&type=template&id=e9dd1258&"
import script from "./SpecialityTab.vue?vue&type=script&lang=js&"
export * from "./SpecialityTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports